import { lazy } from 'react'
import * as Icons from 'react-feather'
import ChunkLoader from "router/ChunkLoader"

const navigation = [
  {
    id: 'home',
    navLink: '/app/home',
    component: lazy(() => ChunkLoader(() => import('views/@vp/app/Passport'))),
    pagePermissions: ["user"],
    title: 'Home',
    icon: <Icons.Clipboard size={20} />
  },
  {
    id: 'applications',
    navLink: '/app/applications',
    component: lazy(() => ChunkLoader(() => import('views/@vp/app/Applications'))),
    pagePermissions: ["user"],
    title: 'Applications',
    icon: <Icons.Archive size={20} />
  },
  {
    id: "assess",
    navLink: "/assess/:uid/:rid/:token",
    component: lazy(() => ChunkLoader(() => import('views/@vp/public/Assessment'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  },
  {
    id: "assess-success",
    navLink: "/assess-success/:uid/:rid/:token",
    component: lazy(() => ChunkLoader(() => import('views/@vp/public/AssessmentSuccess'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  },
  {
    id: "gateway-apply",
    navLink: "/apply/:companyId/:listingId",
    component: lazy(() => ChunkLoader(() => import('views/@vp/public/GatewayApply'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  },
  {
    id: "gateway-apply-alias",
    navLink: "/apply/:alias",
    component: lazy(() => ChunkLoader(() => import('views/@vp/public/GatewayApplyAlias'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  },
  {
    id: "register-apply",
    navLink: "/registerapply/:companyId/:listingId",
    component: lazy(() => ChunkLoader(() => import('views/@vp/public/RegisterApply'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  },
  {
    id: "magic-apply",
    title: "MagicApply",
    navLink: "/magicapply/:companyId/:listingId",
    component: lazy(() => ChunkLoader(() => import('views/@vp/app/MagicApply'))),
    pagePermissions: ["user"],
    layout: 'BlankLayout'
  },
  {
    id: 'productguide',
    navLink: '/app/productguide',
    component: lazy(() => ChunkLoader(() => import('views/@vp/app/ProductGuide'))),
    pagePermissions: ["user"],
    title: 'Product Guide',
    icon: <Icons.Info size={20} />,
    // query: ["jobId"]
  },
]

export default navigation;
